module.exports = __webpack_public_path__ + "static/media/thames-water-logo.743ec3c0.svg";